import Vue from 'vue';
import Vuex from '@store/store';
import {baseUrl, getHeaders, isSignedIn} from '@services/AuthServices';
import {queryFilter} from '@src/filters/query-filter';

Vue.use(Vuex);

// MAIN FUNCTION TO TRANSFORM QUOTATION PAYLOAD
async function transformPayload(operations, parts, quotationType) {
  if (quotationType == 'edit') {
    const frontendPayload = {
      operations: operations ? transformOperations(operations) : [],
      parts: parts ? transformParts(parts) : [],
    };

    let findIam = operations.filter(o => o.isQuotationLaborIAMActive === true);
    if(findIam && findIam.length > 0) {
      const transformOE = {
          operations: operations ? transformOperationsOE(operations) : [],
      }
      transformOE.operations.forEach(op => {
          Vuex.commit('budget/setBudgetPayloadForTotalizersCalcsOE', op);
      });
    }

    return frontendPayload;

    function transformOperations(operations) {
      const storeLaborValues = Vuex.getters['budget/getB2bLaborValues'];

      return operations.map(operation => {

          let setQuotationLaborId = null;
          if(operation.isQuotationLaborIAMActive === true) {
              setQuotationLaborId = operation.quotationLaborIAMId
          } else {
              setQuotationLaborId = operation.quotationLaborOEId
          }

          const durationArray = operation.calculatedTime.toFixed(2).split('.');
          return {
              itemMpId: operation.itemMpId,
              workId: operation.workId,
              reference: operation.reference,
              names: operation.inclusiveWorkPositions ? [operation.description, ...operation.inclusiveWorkPositions.map(work => work.workPosText)] : [operation.description],
              duration: {
                  hours: durationArray[0],
                  minutes: durationArray[1]
              },
              discount: operation.discountMobyLine,
              hourValue: storeLaborValues.find(value => value.id == setQuotationLaborId),
              korId: operation.korId ? operation.korId : '',
              korText: operation.korText ? operation.korText : '',
              entityPackageServiceId: operation?.entityPackageServiceId ? operation.entityPackageServiceId : '',
              kindOfPosition: operation.kindOfPosition == 0 ? 'ServiceWorkPosition' : '',
              hourValueDefault: {
                oe: storeLaborValues.find(labor => labor.quotationLaborId == operation.quotationLaborOEId),
                iam: storeLaborValues.find(labor => labor.quotationLaborId == operation.quotationLaborIAMId),
              },
          };
      });
    }

    function transformParts(parts) {
        let resultParts = {};

        parts.forEach((partRow, indexPart) => {
          resultParts[partRow.itemMpId] = partRow.quotationParts.map((part, index) => {
              const isSelected = part.isSelected || part.hasSelectedIam // if the selected part isIam, we need to know which was the selected oe part
              const hasDiscount = part.quotationIAMParts && part.quotationIAMParts.length > 0 ? part.quotationIAMParts.filter((iamPart) => iamPart.isSelected) : [];
              let directDiscount = part.discountPartsByLine;
              if(hasDiscount && hasDiscount.length > 0) {
                  directDiscount = hasDiscount[0].discountPartsByLine;
              }
              const hasIamPartsToSetIAM = !!(part?.hasSelectedIam && part.hasSelectedIam == true && part.quotationIAMParts.length > 0);
              const stringItemMpId = String(part.itemMpId)
              const isFluid = stringItemMpId.includes('-999');
              return {
                  itemMpId: String(part.itemMpId),
                  name: part.fullDescription ? part.fullDescription : part.description,
                  reference: part.reference,
                  brand: part.brandDescription,
                  price: part.editedPrice,
                  isIam: hasIamPartsToSetIAM,
                  isSelected: isSelected,
                  discount: directDiscount,
                  iamParts: part.quotationIAMParts.map((iamPart, iamPartIndex) => {
                      let qtd = 1;
                      let selectedQtd = '';
                      if(iamPart && iamPart.quotationPartsAmounts) {
                        selectedQtd = iamPart.quotationPartsAmounts.find((q) => q.isSelected);
                        if(iamPart.quotationPartsAmounts.find((q) => q.isSelected)) {
                          qtd = selectedQtd.quantity;
                        } else if (iamPart.quotationPartsAmounts.length == 1) {
                          qtd = iamPart.quotationPartsAmounts[0].quantity;
                        }
                      }
                      if(selectedQtd == "") {
                        qtd = iamPart.quantity
                      }

                      return {
                          itemMpId: part.itemMpId,
                          isSelected: part.hasSelectedIam ? iamPart.isSelected : iamPartIndex === 0, // if iam is not preselected, we select the first option, else all would have isSelected = false
                          reference: iamPart.reference,
                          brand: iamPart.brandDescription,
                          name:  iamPart.description,
                          price: iamPart.editedPrice,
                          costPrice: iamPart.costPrice? iamPart.costPrice : 0,
                          quantity: qtd,
                          priceOriginal: iamPart.partialPricePart == 0 ? iamPart.editedPrice : iamPart.partialPricePart,
                          partialPricePart: iamPart.partialPricePart ? iamPart.partialPricePart : 0,
                          brandId: iamPart.brandId,
                          stockQuantity: iamPart.stockQuantity ? iamPart.stockQuantity : 0,
                          partNo: iamPart.partNo ? iamPart.partNo : iamPart.reference ? iamPart.reference : null,
                          discount: iamPart.discountPartsByLine,
                          partId: iamPart.partId ? iamPart.partId : '',
                          aditionalDescription: iamPart.aditionalDescription ? iamPart.aditionalDescription : '',
                          isFluidMatch: iamPart.isFluidMatch ? iamPart.isFluidMatch : false,
                          workId: iamPart.workId ? iamPart.workId : "",
                          isFavoriteBrand: iamPart.isFavoriteBrand ? iamPart.isFavoriteBrand : false,
                          quotationPartId: iamPart.quotationPartId,
                      };
                  }),
                  quantities: part.quotationPartsAmounts.map((quantity, quantityIndex) => {
                      return {
                          id: quantity.quotationPartAmountID,
                          quantity: quantity.quantity,
                          isSelected: part.hasSelectedIam ? quantityIndex === 0 : quantity.isSelected // quantity only has isSelected at true if the selected piece was OE
                      };
                  }),
                  priceOriginal: part.partialPricePart,
                  costPrice: part.costPrice,
                  workId: part.workId ? String(part.workId) : '',
                  entityPackageServiceId: partRow?.entityPackageServiceId ? partRow.entityPackageServiceId : '',
                  partId: part.partId ? String(part.partId) : '',
                  apiPartOrder: indexPart + 1,
                  isFluid: partRow.isFluid ? partRow.isFluid : isFluid,
                  isEntityPackageService: partRow.isEntityPackageService,
                  isFreePart: partRow.isFreePart,
                  isEcoTax: partRow.isEcoTax,
                  hasMatchVINOE: partRow.hasMatchVINOE,
                  quotationPartId: part.quotationPartId,
              };
          });
        });

        const filteredKeys = Object.keys(resultParts).filter(key => resultParts[key].length > 0);
        return filteredKeys.reduce((acc, key) => {
            acc[key] = resultParts[key];
            return acc;
        }, {});
    }

    function transformOperationsOE(operations) {
        const storeLaborValues = Vuex.getters['budget/getB2bLaborValues'];

        return operations.map(operation => {

            let setQuotationLaborId = operation.quotationLaborOEId;

            const durationArray = operation.calculatedTime.toFixed(2).split('.');
            return {
                itemMpId: operation.itemMpId,
                workId: operation.workId,
                reference: operation.reference,
                names: operation.inclusiveWorkPositions ? [operation.description, ...operation.inclusiveWorkPositions.map(work => work.workPosText)] : [operation.description],
                duration: {
                    hours: durationArray[0],
                    minutes: durationArray[1]
                },
                discount: operation.discountMobyLine,
                hourValue: storeLaborValues.find(value => value.id == setQuotationLaborId),
                korId: operation.korId ? operation.korId : '',
                korText: operation.korText ? operation.korText : '',
                entityPackageServiceId: operation?.entityPackageServiceId ? operation.entityPackageServiceId : '',
                kindOfPosition: operation.kindOfPosition == 0 ? 'ServiceWorkPosition' : ''
            };
        });
    }
  } else if (quotationType == 'create') {
      return {
        operations: operations ? transformOperations(operations) : [],
        parts: parts ? transformParts(parts) : [],
    };

    function transformOperations(operations) {
      const storeFavouriteLaborValue = Vuex.getters['budget/getB2bFavouriteLaborValue'];
      const storeLabors = Vuex.getters['budget/getB2bLaborValue'];
      let favouriteLabor = storeLabors.value.find(labor => labor.isFavourite && !labor.isIAM && labor.isActive);
      const getIamFavouriteLabor = storeLabors.value.find(labor => labor.isIAM && labor.isActive && labor.isFavourite);

      return operations.map(operation => {

          let theKindOfPositionFind = '';
          if(operation && operation.position == 0) {
            theKindOfPositionFind = 'ServiceWorkPosition';
          }

          const durationArray = operation.calculatedTime.toFixed(2).split('.');
          return {
              itemMpId: String(operation.itemMpId),
              workId: String(operation.workId),
              reference: operation.workPositionNo,
              names: [operation.workPosText, ...operation.inclusiveWorkPositions.map(work => work.workPosText)],
              hourValue: storeFavouriteLaborValue,
              duration: {
                  hours: durationArray[0],
                  minutes: durationArray[1]
              },
              hourValueDefault: {
                oe: favouriteLabor,
                iam: getIamFavouriteLabor,
              },
              discount: 0,
              kindOfPosition: theKindOfPositionFind,
              showServicePlan: theKindOfPositionFind,
              korId: operation.korId ? operation.korId : '',
              korText: operation.korText ? operation.korText : '',
              entityPackageServiceId: operation?.entityPackageServiceId ? operation.entityPackageServiceId : ''
          };

      });
    }

    function transformParts(parts) {
      let resultParts = {};
      const partSelected = Vuex.getters['budget/getBudgetSummary'].parts.values;

      parts.forEach((partRow, indexPart) => {
          resultParts[partRow.itemMpId] = partRow.quotationParts.map((part, index) => {
              const isSelected = part.isSelected || part.hasSelectedIam // if the selected part isIam, we need to know which was the selected oe part
              const hasDiscount = part.quotationIAMParts && part.quotationIAMParts.length > 0 ? part.quotationIAMParts.filter((iamPart) => iamPart.isSelected) : [];
              let directDiscount = part.discountPartsByLine;
              if(hasDiscount && hasDiscount.length > 0) {
                  directDiscount = hasDiscount[0].discountPartsByLine;
              }
              const hasIamPartsToSetIAM = !!(part?.hasSelectedIam && part.hasSelectedIam == true && part.quotationIAMParts.length > 0);
              const stringItemMpId = String(part.itemMpId)
              const isFluid = stringItemMpId.includes('-999');
              return {
                  itemMpId: String(part.itemMpId),
                  name: part.fullDescription ? part.fullDescription : part.description,
                  reference: part.reference,
                  brand: part.brandDescription,
                  price: part.editedPrice,
                  isIam: hasIamPartsToSetIAM,
                  isSelected: isSelected,
                  discount: directDiscount,
                  iamParts: part.quotationIAMParts.map((iamPart, iamPartIndex) => {
                      let qtd = 1;
                      let selectedQtd = '';
                      if(iamPart && iamPart.quotationPartsAmounts) {
                        selectedQtd = iamPart.quotationPartsAmounts.find((q) => q.isSelected);
                        if(iamPart.quotationPartsAmounts.find((q) => q.isSelected)) {
                          qtd = selectedQtd.quantity;
                        } else if (iamPart.quotationPartsAmounts.length == 1) {
                          qtd = iamPart.quotationPartsAmounts[0].quantity;
                        }
                      }
                      if(selectedQtd == "") {
                        qtd = iamPart.quantity
                      }

                      let findSelected = partSelected.findIndex(el => el.itemMpId === part.itemMpId);
                      let selectedPart = iamPartIndex === 0;
                      if(findSelected !== -1) {
                          selectedPart = iamPart.genArtDesc == partSelected[findSelected].name;
                      }

                          return {
                              itemMpId: part.itemMpId,
                              isSelected: selectedPart,
                              reference: iamPart.reference,
                              brand: iamPart.brandDescription,
                              name:  iamPart.description,
                              price: iamPart.editedPrice,
                              costPrice: iamPart.costPrice? iamPart.costPrice : 0,
                              quantity: qtd,
                              priceOriginal: iamPart.partialPricePart == 0 ? iamPart.editedPrice : iamPart.partialPricePart,
                              partialPricePart: iamPart.partialPricePart ? iamPart.partialPricePart : 0,
                              brandId: iamPart.brandId,
                              stockQuantity: iamPart.stockQuantity ? iamPart.stockQuantity : 0,
                              partNo: iamPart.partNo ? iamPart.partNo : iamPart.reference ? iamPart.reference : null,
                              discount: iamPart.discountPartsByLine,
                              partId: iamPart.partId ? iamPart.partId : '',
                              aditionalDescription: iamPart.aditionalDescription ? iamPart.aditionalDescription : '',
                              isFluidMatch: iamPart.isFluidMatch ? iamPart.isFluidMatch : false,
                              workId: iamPart.workId ? iamPart.workId : "",
                              isFavoriteBrand: iamPart.isFavoriteBrand ? iamPart.isFavoriteBrand : false,
                              quotationPartId: iamPart.quotationPartId,
                          };
                  }),
                  quantities: part.quotationPartsAmounts.map((quantity, quantityIndex) => {
                      return {
                          id: quantity.quotationPartAmountID,
                          quantity: quantity.quantity,
                          isSelected: part.hasSelectedIam ? quantityIndex === 0 : quantity.isSelected // quantity only has isSelected at true if the selected piece was OE
                      };
                  }),
                  priceOriginal: part.partialPricePart,
                  costPrice: part.costPrice,
                  workId: part.workId ? String(part.workId) : '',
                  entityPackageServiceId: partRow?.entityPackageServiceId ? partRow.entityPackageServiceId : '',
                  partId: part.partId ? String(part.partId) : '',
                  apiPartOrder: indexPart + 1,
                  isFluid: partRow.isFluid ? partRow.isFluid : isFluid,
                  isEntityPackageService: partRow.isEntityPackageService,
                  isFreePart: partRow.isFreePart,
                  isEcoTax: partRow.isEcoTax,
                  hasMatchVINOE: partRow.hasMatchVINOE,
                  quotationPartId: part.quotationPartId,
              };
          });
      });

      const filteredKeys = Object.keys(resultParts).filter(key => resultParts[key].length > 0);
        return filteredKeys.reduce((acc, key) => {
          acc[key] = resultParts[key];
          return acc;
      }, {});
    }
  } else {
      return {
        operations: operations ? transformOperations(operations) : [],
        parts: parts ? transformParts(parts) : []
    };

    function transformOperations(operations) {
        const storeFavouriteLaborValue = Vuex.getters['budget/getB2bFavouriteLaborValue'];
        const storeLabors = Vuex.getters['budget/getB2bLaborValue'];
        let favouriteLabor = storeLabors.value.find(labor => labor.isFavourite && !labor.isIAM && labor.isActive);
        const getIamFavouriteLabor = storeLabors.value.find(labor => labor.isIAM && labor.isActive && labor.isFavourite);

        let kindOfPositionCheck = '';
        if(Vuex.getters['budget/getB2bStep2'].response) {
            if(Vuex.getters['budget/getB2bStep2'].response.distributionAttribut) {
                kindOfPositionCheck = Vuex.getters['budget/getB2bStep2'].response.distributionAttribut;
            }else if(Vuex.getters['budget/getB2bStep2'].response.nextMaintenanceAttribut) {
                kindOfPositionCheck = Vuex.getters['budget/getB2bStep2'].response.nextMaintenanceAttribut;
            } else {
                kindOfPositionCheck = [];
            }
        } else {
            kindOfPositionCheck = [];
        }

        return operations.map(operation => {

            let kindOfPositionFind = kindOfPositionCheck.filter(el => el.workId == operation.workId);
            if(!kindOfPositionFind || kindOfPositionFind.length == 0) {
                kindOfPositionFind = ""
            } else {
                kindOfPositionFind = kindOfPositionFind[0].kindOfPosition;
            }

            const durationArray = operation.calculatedTime.toFixed(2).split('.');
            return {
                itemMpId: operation.itemMpId,
                workId: operation.workId,
                reference: operation.workPositionNo,
                names: [operation.workPosText, ...operation.inclusiveWorkPositions.map(work => work.workPosText)],
                hourValue: storeFavouriteLaborValue,
                duration: {
                    hours: durationArray[0],
                    minutes: durationArray[1]
                },
                discount: operation.discount ? operation.discount : 0,
                kindOfPosition: kindOfPositionFind == '' ? operation?.position == 0 ? 'ServiceWorkPosition' : '' : kindOfPositionFind,
                korId: operation.korId ? operation.korId : '',
                korText: operation.korText ? operation.korText : '',
                entityPackageServiceId: operation?.entityPackageServiceId ? operation.entityPackageServiceId : '',
                hourValueDefault: {
                  oe: favouriteLabor,
                  iam: getIamFavouriteLabor,
                },
            };

        });
    }

    function transformParts(parts) {
      let resultParts = {};
      const partSelected = Vuex.getters['budget/getBudgetSummary'].parts.values;

      parts.forEach((partRow, indexPart) => {
          resultParts[partRow.itemMpId] = partRow.quotationParts.map((part, index) => {
              const isSelected = part.isSelected || part.hasSelectedIam // if the selected part isIam, we need to know which was the selected oe part
              const hasDiscount = part.quotationIAMParts && part.quotationIAMParts.length > 0 ? part.quotationIAMParts.filter((iamPart) => iamPart.isSelected) : [];
              let directDiscount = part.discountPartsByLine;
              if(hasDiscount && hasDiscount.length > 0) {
                  directDiscount = hasDiscount[0].discountPartsByLine;
              }
              const hasIamPartsToSetIAM = !!(part?.hasSelectedIam && part.hasSelectedIam == true && part.quotationIAMParts.length > 0);
              const stringItemMpId = String(part.itemMpId)
              const isFluid = stringItemMpId.includes('-999');
              return {
                  itemMpId: String(part.itemMpId),
                  name: part.fullDescription ? part.fullDescription : part.description,
                  reference: part.reference,
                  price: part.editedPrice,
                  isIam: hasIamPartsToSetIAM,
                  isSelected: isSelected,
                  discount: directDiscount,
                  iamParts: part.quotationIAMParts.map((iamPart, iamPartIndex) => {
                      let qtd = 1;
                      let selectedQtd = '';
                      if(iamPart && iamPart.quotationPartsAmounts) {
                        selectedQtd = iamPart.quotationPartsAmounts.find((q) => q.isSelected);
                        if(iamPart.quotationPartsAmounts.find((q) => q.isSelected)) {
                          qtd = selectedQtd.quantity;
                        } else if (iamPart.quotationPartsAmounts.length == 1) {
                          qtd = iamPart.quotationPartsAmounts[0].quantity;
                        }
                      }
                      if(selectedQtd == "") {
                        qtd = iamPart.quantity
                      }

                      let findSelected = partSelected.findIndex(el => el.itemMpId === part.itemMpId);
                      let selectedPart = iamPartIndex === 0;
                      if(findSelected !== -1) {
                          selectedPart = iamPart.genArtDesc == partSelected[findSelected].name;
                      }

                          return {
                              itemMpId: part.itemMpId,
                              isSelected: selectedPart,
                              reference: iamPart.reference,
                              brand: iamPart.brandDescription,
                              name:  iamPart.description,
                              price: iamPart.editedPrice,
                              costPrice: iamPart.costPrice? iamPart.costPrice : 0,
                              quantity: qtd,
                              priceOriginal: iamPart.partialPricePart == 0 ? iamPart.editedPrice : iamPart.partialPricePart,
                              partialPricePart: iamPart.partialPricePart ? iamPart.partialPricePart : 0,
                              brandId: iamPart.brandId,
                              stockQuantity: iamPart.stockQuantity ? iamPart.stockQuantity : 0,
                              partNo: iamPart.partNo ? iamPart.partNo : iamPart.reference ? iamPart.reference : null,
                              discount: iamPart.discountPartsByLine,
                              partId: iamPart.partId ? iamPart.partId : '',
                              aditionalDescription: iamPart.aditionalDescription ? iamPart.aditionalDescription : '',
                              isFluidMatch: iamPart.isFluidMatch ? iamPart.isFluidMatch : false,
                              workId: iamPart.workId ? iamPart.workId : "",
                              isFavoriteBrand: iamPart.isFavoriteBrand ? iamPart.isFavoriteBrand : false,
                              quotationPartId: iamPart.quotationPartId,
                          };
                  }),
                  quantities: part.quotationPartsAmounts.map((quantity, quantityIndex) => {
                      return {
                          id: quantity.quotationPartAmountID,
                          quantity: quantity.quantity,
                          isSelected: part.hasSelectedIam ? quantityIndex === 0 : quantity.isSelected // quantity only has isSelected at true if the selected piece was OE
                      };
                  }),
                  priceOriginal: part.partialPricePart,
                  costPrice: part.costPrice,
                  workId: part.workId ? String(part.workId) : '',
                  entityPackageServiceId: partRow?.entityPackageServiceId ? partRow.entityPackageServiceId : '',
                  partId: part.partId ? String(part.partId) : '',
                  apiPartOrder: indexPart + 1,
                  isFluid: partRow.isFluid ? partRow.isFluid : isFluid,
                  isEntityPackageService: partRow.isEntityPackageService,
                  isFreePart: partRow.isFreePart,
                  isEcoTax: partRow.isEcoTax,
                  hasMatchVINOE: partRow.hasMatchVINOE,
                  quotationPartId: part.quotationPartId,
              };
          });
      });

      const filteredKeys = Object.keys(resultParts).filter(key => resultParts[key].length > 0);
        return filteredKeys.reduce((acc, key) => {
          acc[key] = resultParts[key];
          return acc;
      }, {});
    }
  }
}

// QUOTATION - EDIT AND PREVIEW MODE
export async function QuotationServicesGetQuotation(quotationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}`;

    return axios
        .get(urlApi, getHeaders(true))
        .then(async response => {

            if(response.data.result.quotationLabors && response.data.result.quotationLabors.length > 0) {
                const payload = {
                    value: response.data.result.quotationLabors
                };

                for (let item in response.data.result.quotationLabors) {
                    if (response.data.result.quotationLabors[item].isFavourite && !response.data.result.quotationLabors[item].isIAM) {
                        payload.isFavourite = response.data.result.quotationLabors[item].labor;
                        break;
                    }
                }

                Vuex.commit('budget/setB2bLaborValue', payload);
            }

            if(response.data?.result?.quotationInfoClient) {
                Vuex.commit('budget/setStateClientInfo', response.data.result.quotationInfoClient);
            }

            if(response.data?.result?.quotationType) {
                Vuex.commit('budget/setQuotationType', { id: response.data.result.quotationTypeId, description: response.data.result.quotationType});
            } else {
                Vuex.commit('budget/setQuotationType', {});
            }

            let operationsParts = null;
            if(response.data?.result?.quotationTypeId != 4){
                operationsParts = await transformPayload(response.data.result.quotationWorks, response.data.result.quotationItemMpIds, 'edit');
            }

            return {
                result: response.data.result,
                ...operationsParts,
                operationsGlobalDiscount: response.data.result.quotationValueOE ? response.data.result.quotationValueOE.subTotalDiscountMO : 0,
                partsGlobalDiscount: response.data.result.quotationValueIAM ? response.data.result.quotationValueIAM.subTotalDiscountParts : response.data.result.quotationValueOE ? response.data.result.quotationValueOE.subTotalDiscountParts : 0,
            }
        })
        .catch(error => {
            console.error('QuotationServicesGetData promise', error);
        });
}

// QUOTATION - CREATE MODE
export async function QuotationServicesGetData(arrayIds, internalId, quotationId, idToDelete, partId) {
    await isSignedIn();
    let operationsVar = '';
    let partsVar = '';
    let transformVar = '';
    let operationsPromise = '';
    let partsPromise = '';

    let newOpBody = {
      "selectedWorkIds": [],
    };
    let newPartsBody = {
      "selectedWorkIds": [],
    }
    arrayIds.forEach(item => {
      newOpBody.selectedWorkIds.push(item);
      newPartsBody.selectedWorkIds.push(item);
    });

    if(quotationId) {
      newOpBody['quotationId'] = quotationId;
      newPartsBody['quotationId'] = quotationId;
    }

    // Neste caso, se o copyCart existir quer dizer que não é primera vez que faz loading no orçamento, então a flag vai a false
    const copyCart = JSON.parse(localStorage.getItem('@copyShoppingCart'));
    if(copyCart) {
      newOpBody['returnPackageServices'] = false;
      newPartsBody['returnPackageServices'] = false;
    } else {
      newOpBody['returnPackageServices'] = true;
      newPartsBody['returnPackageServices'] = true;
    }

    // if(idToDelete) {
    //   if(String(idToDelete).includes('-998')){
    //     let newObj = {
    //       "workId": idToDelete,
    //       "isSelected": false
    //     }
    //     newOpBody.selectedWorkIds.push(newObj)
    //     newPartsBody.selectedWorkIds.push(newObj)
    //   }
    // }
    newPartsBody['removePartIDs'] = [];
    const getShoppingCartOperations = Vuex.getters['budget/getB2bCurrentShoppingCart'].operations;
    const concatMaintenanceWithRepairLists = getShoppingCartOperations.maintenance.concat(getShoppingCartOperations.repair);
    const existKitOnList = concatMaintenanceWithRepairLists.find(item => item.itemMpId == 127);
    if(existKitOnList) {
      const getStateOfKit = Vuex.getters['budget/getStateOfClutchKit'];
      newPartsBody['removePartIDs'] = getStateOfKit.removePartIDs;
    }
    if(partId) {
      newPartsBody['removePartIDs'].push(partId);
    }

    if(!newOpBody.selectedWorkIds || newOpBody.selectedWorkIds.length == 0) {
        return new Promise((_, reject) => {
            reject(new Error('REDIRECT_BACK'));
        });
    }

    try {
        operationsPromise = QuotationServicesPostInternalMaintenanceOperations(newOpBody)
            .then(response => {
                operationsVar = response.data.result;
            })
            .catch(error => {
                operationsVar = [];
            })
            .finally(() => {
            })

        partsPromise = QuotationServicesPostInternalMaintenanceParts(newPartsBody)
            .then(response => {
                partsVar = response.data.result;
            })
            .catch(error => {
                partsVar = [];
            })
            .finally(() => {
            })

/*             operationsPromise = QuotationServicesGetMaintenanceOperations(arrayIds, internalId)
            .then(response => {
                operationsVar = response.data.result;
            })
            .catch(error => {
                operationsVar = [];
            })
            .finally(() => {
            })

            partsPromise = QuotationServicesGetMaintenanceParts(arrayIds, internalId)
            .then(response => {
                partsVar = response.data.result;
            })
            .catch(error => {
                partsVar = [];
            })
            .finally(() => {
            }) */
    } catch (e) {

    } finally {
        return Promise.all([operationsPromise, partsPromise])
        .then(async response => {
            transformVar = await transformPayload(operationsVar, partsVar, 'create');
            return transformVar;
        })
        .catch(error => {
            console.error('QuotationServicesGetData promise (QuotationServicesGetData) ', error);
        });
    }

    function QuotationServicesPostInternalMaintenanceOperations(body) {
        const urlApi = `${baseUrl}/Quotation/internal-maintenance-operations`;

        return axios.post(urlApi, body, getHeaders(true));
    }

    function QuotationServicesPostInternalMaintenanceParts(body) {
        const urlApi = `${baseUrl}/Quotation/internal-maintenance-parts`;

        return axios.post(urlApi, body, getHeaders(true));
    }
}

// QUOTATION - INTERNAL MODE - ACTIVE RECEPTION
export async function QuotationServicesGetEstimateInternalData(operationsBody, partsBody) {
  await isSignedIn();
  let operationsVar = '';
  let partsVar = '';
  let transformVar = '';
  let operationsPromise = '';
  let partsPromise = '';
  try {
    operationsPromise = QuotationServicesPostInternalMaintenanceOperations(operationsBody)
    .then(response => {
      operationsVar = response.data.result;
    })
    .catch(error => {
      operationsVar = [];
    })

    if(partsBody && partsBody.selectedWorkIds && partsBody.selectedWorkIds.length > 0) {
      partsPromise = QuotationServicesPostInternalMaintenanceParts(partsBody)
      .then(response => {
          partsVar = response.data.result;
      })
      .catch(error => {
          partsVar = [];
      })
    } else {
      partsVar = [];
    }
  } catch (e) {
    console.error(e);
  } finally {
    return Promise.all([operationsPromise, partsPromise])
      .then(async response => {
          transformVar = await transformPayload(operationsVar, partsVar, 'internaldata');
          return transformVar;
      })
      .catch(error => {
          console.error('QuotationServicesGetEstimateInternalData promise (QuotationServicesGetEstimateInternalData) ', error);
      });
  }

    function QuotationServicesPostInternalMaintenanceOperations(body) {
        const urlApi = `${baseUrl}/Quotation/internal-maintenance-operations`;

        return axios.post(urlApi, body, getHeaders(true));
    }

    function QuotationServicesPostInternalMaintenanceParts(body) {
        const urlApi = `${baseUrl}/Quotation/internal-maintenance-parts`;

        return axios.post(urlApi, body, getHeaders(true));
    }
}

export async function QuotationServicesPrint(quotationId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/simulation-pdf`;

    return axios.post(urlApi, body, { ...getHeaders(true), responseType: 'blob' });
}

export async function QuotationServicesSendEmailAndPDF(quotationId, bodyPayload, isEmail) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/simulation-pdf`;
    let payload = {
      ...bodyPayload,
      sendEmail: isEmail
    }
    if(quotationId) {
      payload['quotationId'] = quotationId;
    }
    if(bodyPayload?.quotationFormEmail) {
      if(bodyPayload.quotationFormEmail?.includeImages && bodyPayload.quotationFormEmail?.includeImages == true) {
        delete payload.quotationFormEmail.includeImages;
        payload['includeImages'] = true;
      }
      if (
          bodyPayload.quotationFormEmail?.includeOESelection &&
          bodyPayload.quotationFormEmail?.includeOESelection == true
      ) {
          delete payload.quotationFormEmail.includeOESelection;
          payload["includeOESelection"] = true;
      }
    }

    return axios.post(urlApi, payload,  {...getHeaders(true), responseType: 'blob' });
}

export async function QuotationServicesGetServiceProposal(payload) {
    await isSignedIn();

    const query = queryFilter(payload);
    const urlApi = `${baseUrl}/Quotation/maintenance/service-proposal${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesLabor() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetLaborValues`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetMaintenancePlanHtml(id) {
    await isSignedIn();

    // Check if step1 is empty
    let dateFormated = '';
    let kms = '';
    let step1 = Vuex.getters['budget/getStateB2b'].step1;
    if(Object.keys(step1).length === 0 && step1.constructor === Object) {
        Vuex.getters['vehicleIdentification/getState'].data.forEach((item, index) => {
            if (item.description === 'Plate_Date') {
                let arrayDate = item.value.split('');
                dateFormated = `${arrayDate[0]}${arrayDate[1]}${arrayDate[2]}${arrayDate[3]}-${arrayDate[4]}${arrayDate[5]}-${arrayDate[6]}${arrayDate[7]}`;
            }
        });
    } else {
      Vuex.getters['vehicleIdentification/getState'].data.forEach((item, index) => {
        if (item.description === 'Plate_Date') {
            let arrayDate = item.value.split('');
            dateFormated = `${arrayDate[0]}${arrayDate[1]}${arrayDate[2]}${arrayDate[3]}-${arrayDate[4]}${arrayDate[5]}-${arrayDate[6]}${arrayDate[7]}`;
        }
      });
        kms = Vuex.getters['budget/getStateB2b'].step1.fields.Kilometers
    }

    id = id ? (id.length > 0 ? id : [id]) : 0;

    if(typeof id == 'string') {
      id = [id];
    }

    const data = {
        serviceworkIds: id,
        additionalWorkIds: id,
        date: dateFormated,
        kilometers: kms,
        printView: false
    };

    const urlApi = `${baseUrl}/Quotation/GetMaintenancePlanHtml`;

    return axios.post(urlApi, data, getHeaders(true));
}

export async function QuotationServicesSendBudgetInfo(data, quotationId) {
    await isSignedIn();

    let param = "";
    if(quotationId){
        param = quotationId;
    }
    const urlApi = `${baseUrl}/Quotation/${param}`;

    return axios.put(urlApi, data, getHeaders(true));
}

export async function QuotationServicesGetQuotationHistory(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/history`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function QuotationServicesGetAdditionalMaintenanceParts(partNo, internalId) {
    await isSignedIn();

    const query = queryFilter({ partNo, internalId });
    const urlApi = `${baseUrl}/Quotation/GetAdditionalMaintenanceParts${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesOrderParts(quotationId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/order-parts`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function BudgetServicePostOperationsFromItemMpIdAndKorId(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/operations-from-itemmpid-korid`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function BudgetServiceGetSimpleRevisionOperations() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetSimpleRevisionOperations`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetWebShop(quotationId) {
    await isSignedIn();

    const query = queryFilter({ quotationId });
    const urlApi = `${baseUrl}/Quotation/integrate-webshop${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetRejectReasons() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/dropdown/reject-reasons`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetEntityBrands(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${entityId}/brands`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesPostOrderTyres(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/tyres/order`;

    return axios.post(urlApi, body ,getHeaders(true));
}

export async function QuotationServicesPostSimulatePrices(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/simulate-prices`;

    return axios.post(urlApi, body ,getHeaders(true));
}

export async function QuotationServicesGetOptionsClutchKit() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/options/clutch-kit`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesRequestQuotationErpInvoice(quotationId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/erp/request-invoice`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function QuotationServicesGetCustomerErpInformation(nif) {
    await isSignedIn();

    const query = queryFilter({ nif });
    const urlApi = `${baseUrl}/Quotation/erp/customer${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesDownloadQuotationErpInvoice(quotationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/erp/download-invoice`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetClientInformation(quotationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/client-information`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetMaintenanceVariables(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetMaintenanceVariables`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function QuotationServicesGetPossibleGearBox() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetPossibleGearBox`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesDownloadIamRequest(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/iam/download-request`;

    return axios.post(urlApi, body, { ...getHeaders(true), responseType: 'blob' });
}

export async function QuotationServicesGetManufacturerManual() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/manufacturer-manual-html`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetJoblistSimulationPDF(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/joblist/simulation-pdf`;

    return axios.post(urlApi, body, {...getHeaders(true), responseType: 'blob' });
}

export async function QuotationServicesGetPriceFromEucon(reference, quotationId) {
    await isSignedIn();

    const query = queryFilter({ reference, quotationId });
    const urlApi = `${baseUrl}/Quotation/reference/eucon-price${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesGetQuotationAvailableMaintenanceRepair() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/available-maintenance-repair`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationServicesSynchronizeDSB(quotationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/dsb/sync`;

    return axios.post(urlApi, {}, getHeaders());
}

export async function QuotationServicesDeleteQuotation(quotationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/${quotationId}/delete`;

    return axios.delete(urlApi, getHeaders(true));
}
